var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 18 14","fill":"#6D607E","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9 0.25L0.75 4.75L3.75 6.385V10.885L9 13.75L14.25 10.885V6.385L15.75 5.5675V10.75H17.25V4.75L9 0.25ZM14.115 4.75L9 7.54L3.885 4.75L9 1.96L14.115 4.75ZM12.75 9.9925L9 12.04L5.25 9.9925V7.2025L9 9.25L12.75 7.2025V9.9925Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }